<template>
	<div class="feedback-view">
		<nav-bar class="header">意见反馈</nav-bar>
		<feedback-list v-if="listVisible" :list="list" @detail="onClickDetail" @add="onClickAdd"/>
		<feedback-detail v-if="detailVisible" :detail="detail"/>
		<feedback-form v-if="formVisible" @submit="onSubmit"/>
	</div>
</template>
<script>
import NavBar from "../../components/nav-bar/index";
import FeedbackList from "./components/feedback-list";
import FeedbackDetail from "./components/feedback-detail";
import FeedbackForm from "./components/feedback-form";

let toast;

export default {
	name: 'Feedback',
	components: {FeedbackForm, FeedbackDetail, FeedbackList, NavBar},
	data() {
		return {
			list: [],
			loading: false,
			listVisible: false,
			detailVisible: false,
			formVisible: false,
			detail: null
		};
	},
	watch: {
		loading(loading) {
			if (!toast) {
				toast = this.$createToast({
					type: 'loading',
					text: '加载中...'
				});
			}
			if (loading) {
				toast.show();
			} else {
				toast.hide();
			}
		}
	},
	activated() {
		this.loading = true;
		this.$nextTick(() => {
			this.fetchList();
		});
	},
	beforeRouteLeave(to, from, next) {
		if ((!!this.list.length && this.formVisible) || this.detailVisible) {
			this.listVisible = true;
			this.detailVisible = false;
			this.formVisible = false;
			next(false);
		} else {
			next();
		}
	},
	methods: {
		fetchList() {
			this.$UserService.fetchFeedbackList().then((list = []) => {
				this.list = [...list];
				let hasItems = this.list.length > 0;
				this.listVisible = hasItems;
				this.detailVisible = false;
				this.formVisible = !hasItems;
				this.loading = false;
			});
		},
		onClickDetail(record) {
			console.log(record);
			this.detail = record;
			this.listVisible = false;
			this.detailVisible = true;
			this.formVisible = false;
		},
		onClickAdd() {
			this.listVisible = false;
			this.detailVisible = false;
			this.formVisible = true;
		},
		onSubmit() {
			this.listVisible = true;
			this.detailVisible = false;
			this.formVisible = false;
			this.fetchList();
		}
	}
}
</script>

<style scoped lang="scss">
	@import "../../assets/style/common.scss";
	.feedback-view {
		@extend .common-page;
	}
	.header {
		position: sticky;
		top: 0;
		z-index: 10;
	}
</style>
